export default {
  id: 114,
  title: 'Target #114 - Negative Box',
  url: 'https://cssbattle.dev/play/114',
  colors: ['#172D2C', '#E9AF53'],
  solution:
    '<p><style>body{background:#172d2c;margin:0}p{width:400;height:300;background:#e9af53;clip-path:polygon(200px 20px,380px 85px,200px 150px,20px 85px,20px 215px,200px 280px)}</style>',
}
